import React from 'react';
import { useFormikContext } from 'formik';
import { useTranslator } from '@front-activerse/common-components';
import { goalSettings } from '../types';

export const Summary: React.FC = () => {
  const { t } = useTranslator();
  const { values } = useFormikContext<goalSettings>();
  const { preferredMacronutrientRatio } = values;

  return (
    <>
      <h2 className="mb-m title-large semi-bold">{t('goalSettings.summary.headline')}</h2>
      <p className="mb-xl text-text-variant-color">{t('goalSettings.summary.description')}</p>
      <div>
        <dl>
          <dt>{t('nutritionSettings.summary.list.macros')}</dt>
          <dd>
            {t('summary.macros.proteinsShort')} {preferredMacronutrientRatio?.protein}%{', '}
            {t('summary.macros.fatsShort')} {preferredMacronutrientRatio?.fat}%{', '}
            {t('summary.macros.carbsShort')} {preferredMacronutrientRatio?.carbohydrate}%
          </dd>
        </dl>
      </div>
    </>
  );
};

export default Summary;
